
    export const environment = {
        production: true,
        apiUrl: 'https://supplier-d1-worker.itsupport-0b7.workers.dev',
        authUrl: ''
    }
